module.exports = __webpack_public_path__ + "bafd4f3ad196dba98c7c488e55eac8a6.svg";